import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const useReservationDate = (idSubSpace) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  const goBack = () => {
    const isDesktop = document.querySelector('.m-hide') !== null;
    navigate(
      idSubSpace
        ? isDesktop
          ? '/detalle-espacio/space/' + idSubSpace + '/true'
          : '/confirmar-reservacion2nd/booking/' + idSubSpace + '/true'
        : '/',
    );
  };

  const goToReservationTime = () => {
    //ReactPixel.trackCustom('clickReservationButton', { clave: spaceData });
    navigate(idSubSpace ? '/reservation-time/' + idSubSpace : '/reservation-time');
  };

  const handleSubmit = async (values, onReservationDate) => {
    setLoading(true);
    setError(null);
    try {
      await onReservationDate(values);
    } catch (err) {
      setError('Error reservation date. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    error,
    handleSubmit,
    goBack,
    goToReservationTime,
  };
};
